module.exports = __webpack_public_path__ + "portal-static/img/test.9937eab7.jpg";